"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmptyCart_1 = require("./EmptyCart");
exports.default = EmptyCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EmptyCart/index.js
// module id = 792
// module chunks = 8